// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Gd-z","mainContent":"Hd-z","activeSidebar":"Id-z"};